import { Route, Routes, Navigate } from "react-router-dom"

import { useGetEnabledModulesInApp, useRoleIsReadOnly } from "@l2r-front/l2r-networks"

import { Report } from "../../../modules/incidents/containers/Report"
import { ReportContextProvider } from "../../../modules/incidents/contexts/ReportContext"
import { appSafety } from "../../constants/appSafety"
import { MODULE_INCIDENTS } from "../../constants/modules"
import { SafetyDesktopLayout } from "../../layouts/SafetyDesktopLayout"

export function SafetyDesktopRouter() {
    const readOnly = useRoleIsReadOnly()
    const enabledSafetyModule = useGetEnabledModulesInApp(appSafety)

    return (
        <Routes>
            {
                readOnly ? <Route
                    path={`${MODULE_INCIDENTS}/:eventId/analysis/*`}
                    element={<Navigate replace to={`../${MODULE_INCIDENTS}`} />}
                />
                    : <Route
                        path={`${MODULE_INCIDENTS}/:eventId/analysis/*`}
                        element={
                            <ReportContextProvider>
                                <Report />
                            </ReportContextProvider>
                        }
                    />
            }
            <Route
                path="/*"
                element={
                    <SafetyDesktopLayout />
                }
            />
            <Route
                path="/"
                element={
                    <Navigate replace to={enabledSafetyModule?.[0]?.path ? enabledSafetyModule?.[0]?.path : ""} />
                }
            />
        </Routes>
    )
}
